import { observable, computed, action, toJS } from 'mobx';
import { mesAutobind, instance } from '@posco/posco-shared';
import O10g015460Repository from '../repository/O10g015460Repository';
import {dialog, message, notification} from "@posco/posco-ui-react";


@mesAutobind
class O10g015460Store {

  @instance(O10g015460Repository.instance) static instance;

  repository;

  @observable _statusFlag = {
    disabled : true,
    btnStatus : 0,
  };

  @observable
  _pageInfo = {
    totalElements: 0,
    totalPages: 0,
    number: 1
  };


  @computed
  get pageInfo() {
    return toJS(this._pageInfo);
  }

  @action
  clearPageInfo() {
    console.log('클리어')
    this._pageInfo = {
      totalElements: 0,
      totalPages: 0,
      number: 1
    };
  }


  @action
  setPage(page) {
    console.log('스토어페이징')
    this._pageInfo.number = page;
    this.onRetrieveAllUser030s();
  }

  @computed
  get statusFlag() {
    return toJS(this._statusFlag);
  }

  @observable _version = '';

  @computed
  get version() {
    return toJS(this._version);
  }


  @action
  setVersion(param) {
    this._version = param;
    // console.log("_version",this._version );
  }

  @observable
  _searchVersion = [];

  @computed
  get searchVersion() {
    return toJS(this._searchVersion);
  }


  /******개인정보처리방침*****/

  @observable
  _user030s = [];

  @computed
  get user030s() {
    return toJS(this._user030s);
  }

  @action
  setUser030s(param) {
    this._user030s = param;
    // console.log("_version",this._version );
  }



  @computed
  get itclearConfirmTp() {
    return toJS(this._itclearConfirmTp);
  }

  @action
  clearItclearConfirmTp() {
    this._itclearConfirmTp = '';
  }

  @action
  setItclearConfirmTp(itclearConfirmTp) {
    this._itclearConfirmTp = itclearConfirmTp;
  }


  /**탭 선택**/
  @observable _tabActive = 0;
  @computed get tabActive() { return toJS(this._tabActive); }
  @action
  setTabActive(param) {
    this._tabActive = param;
    // console.log("_findId", this._tabActive );
  }



  /**아이디 찾기**/
  @observable _findId = {
    employeeName: '',
    emailAddress: '',
  };

  @computed get findId() { return toJS(this._findId); }

  @action
  setFindId(param) {
    this._findId = param;
    // console.log("_findId", this._findId );
  }

  @action
  clearFindId() {
    // this.setFindId({});
    this._findId.employeeName='';
    this._findId.emailAddress='';
    // console.log("클리어아이디", this.findId, this.findId.employeeName);
  }

  /**비밀번호 찾기**/
  @observable _findPW = {
    employeeName: '',
    emailAddress: '',
    smrtNoteUserId: '',
  };

  @computed get findPW() { return toJS(this._findPW); }

  @action
  setFindPW(param) {
    this._findPW = param;
    // console.log("_findPW", this._findPW );
  }

  @action clearFindPW() {
    // this.setFindPW({});
    this._findPW.employeeName='';
    this._findPW.emailAddress='';
    this._findPW.smrtNoteUserId='';
  }

  @observable _explan = '';

  @computed
  get explan() {
    return toJS(this._explan);
  }

  @action
  setExplan(param) {
    this._explan = param;
    // console.log("_version",this._version );
  }

  @action
  onChange(e, data){
    // console.log("e,data===",e, data);
    this._searchVersion[data.name] = data.value;
    // console.log("this.searchVersion", this.searchVersion)
  }

  @action
  changeDisabled(value, index) {
    if(index === 1) {
      // this._rowData = O10b013061Model.instance.copyBeforeRowData(this.rowData);
    }
    this._statusFlag.btnStatus = 2;
    this._statusFlag.disabled = false;
  }

  /**회원가입시 개인정보처리방침**/
  @action
  onRetrieveAllUser030s() {
    console.log('회원가입시 개인정보처리방침!!'+this.pageInfo.number)
    return O10g015460Repository.instance
      .onRetrieveAllUser030s(this.pageInfo.number, this.itclearConfirmTp)
      .then(action( result => {
        this._user030s = result.content[0];

        // this._pageInfo = result.pageInfo;
        console.log("개인정보처리방침:::::: ", result.content[0]);
        // this._manPrcStexExpl2 =  result.content[0].manPrcStexExpl2;
        // this._manPrcStexExpl3 =  result.content[0].manPrcStexExpl3;
      }));
  }

  /***개인정보 방침 version****/
  //전체 검색
  @action
  onFindVersion() {
    return O10g015460Repository.instance.onFindVersion()
      .then(action(async result => {
        let options = [];
        if(result.length<1) {
          // console.log("개인정보없음");
          options.push({text: 0, value: 0})
        }
        else {
          // console.log("개인정보있음");
          for (let i = 0; i < result.length; i++) {
            // console.log(" this.result[i]", result[i]);
            options.push({text: result[i].stdTrsMsgVersion, value: result[i].stdTrsMsgVersion})
          }
        }
          this._searchVersion = options; //집어넣기(observerble 변수로 가져오기)
          // console.log("this.searchVersion[0].value",this.searchVersion[0].value);
          this._version = this.searchVersion[0].value;
            // console.log("searchVersion~!~!", this.searchVersion);
          await this.onFindExpl(this.version);
      }));
  }

  //전체 검색
  @action
  onFindExpl(param) {
    return O10g015460Repository.instance.onFindExpl(param)
      .then(action(result => {
        console.log("onFindExpl 조회 ggg", result);
        this._explan = result;
        console.log("설명~!~!", this.explan);
      }));
  }

  /**외부사용자**/
  @action
  saveExternalUserAuthority(externalUserAuthorityModel) {
    return O10g015460Repository.instance.saveExternalUserAuthority(externalUserAuthorityModel)
      .then(action(result => {
        if (result) {
          if (result.status === 200) {
            // notification
            // const msgNoti = "신청되었습니다";
            // notification(message(msgNoti));
          } else if (result.status === 2) {
            if (result.reasonParam === 'webUserEmail') {
              alert('중복된 이메일입니다.');
            } else if (result.reasonParam === 'smrtNoteUserId') {
              alert('이미 사용중인 ID입니다.');
            }
          }
        } else {
          alert('서버 에러가 발생하였습니다.');
        }
      }));
  }

  /**외부사용자 아이디 찾기**/
  @action
  onFindId(rows){
    return O10g015460Repository.instance.onFindId(rows)
      .then(result=>result);
  }

  /**외부사용자 비번 찾기**/
  @action
  onFindPW(rows){
    return O10g015460Repository.instance.onFindPW(rows)
      .then(result=>result);
  }

  /**공급사 권한신청(회원가입 시) 아이디 중복체크**/
  @action
  onDuplicateId(id){
    return O10g015460Repository.instance.onDuplicateId(id)
      .then(action(async result => {
        console.log("ID 중복체크 id", id);
        console.log("ID 중복체크 store", result);
        return result;
      }));
  }

  /**패밀리 권한신청(회원가입 시) 아이디 중복체크**/
  @action
  onDupFamilyId(id){
    return O10g015460Repository.instance.onDupFamilyId(id)
      .then(action(async result => {
        console.log("ID 중복체크 id", id);
        console.log("ID 중복체크 store", result);
        return result;
      }));
  }

  @action
  onDuplicateEmail(email){
    return O10g015460Repository.instance.onDuplicateEmail(email)
      .then(action(async result => {
        console.log("email 중복체크 email", email);
        console.log("email 중복체크 store", result);
        return result;
      }));
  }


  @action
  loginWithCert(userInfo){
    return O10g015460Repository.instance.loginWithCert(userInfo)
      .then(action(result => {
        console.log("인증서 store", result);
        return result;
      }));
  }



}

export default O10g015460Store;
